import React from 'react';
import { TagsComponent } from '@nykaa/product-card-shared';
import { styled } from '@nykaa/ui-components';
import Tag from './index';
const Container = styled.div `
  ${({ theme }) => theme.typography.type122};
  margin: ${({ theme }) => theme.spacing.spacing40};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  text-transform: uppercase;
`;
const List = styled.ul `
  padding-left: 0;
  list-style: none;
  margin: 0 0 10px;
  display: flex;
`;
function Tags({ showMultipleTag = false, tags, offersCount = 0, newTags = [], }) {
    return (React.createElement(Container, null,
        React.createElement(List, null,
            React.createElement(TagsComponent, { showMultipleTag: showMultipleTag, tags: tags, newTagsStyle: newTags, offersCount: offersCount, Component: Tag }))));
}
export default Tags;
